import styled from 'styled-components';
import {alignStart, dFlexColumn} from '../../../../../../globalVariables/GlobalFlex';
import {getSpacing, getFontSize, getFontWeight, tokens} from '@tickchak/react-share/app';
import {ellipsisLines, mobileMedia} from '../../../../../../globalVariables/GlobalVariables';

export const section = styled.div`
    width: 100%;
    padding: ${getSpacing('spaceLg')};
    border-radius: 10px;
    background: ${tokens.primitives.turquoise.turquoise100};
    border: 1px solid var(--color-brand-main);
    margin-block: ${getSpacing('spaceXl')};
    ${mobileMedia}{
        padding: ${getSpacing('spaceSm')};
    }
`;
export const sectionContent = styled.div`
    ${dFlexColumn}
    ${alignStart}
    gap: ${getSpacing('spaceMd')};
    width: 100%;
    max-height: 230px;
    flex-wrap: wrap;
    margin-block: ${getSpacing('spaceXl')};

`;
export const sectionTitle = styled.h3`
    font-size: ${getFontSize('body')};
    font-weight: ${getFontWeight('semibold')};
    color: var(--color-text-default);
    margin: 0;
`;

export const detailItem = styled.div`
    max-width: 50%;
`;

export const label = styled.div`
    font-size: ${getFontSize('body')};
    font-weight: ${getFontWeight('semibold')};
    color: var(--color-text-default);
    min-width: 150px;
`;

export const value = styled.div`
    font-size: ${getFontSize('body')};
    color: var(--color-text-default);
    ${ellipsisLines(2)}
`;

